import html2canvas from 'html2canvas';

/**
 * Creates and displays a toast notification message.
 * @param {string} message The message to display.
 */
function showToastMessage(message) {
	// Create the toast element
	const toast = document.createElement('div');
	toast.textContent = message;
	toast.className = 'mavis-toast-notification';
	document.body.appendChild(toast);

	// Animate it in
	setTimeout(() => {
		toast.classList.add('show');
	}, 100); // Small delay to allow CSS transitions to work

	// Hide and remove the element after 3 seconds
	setTimeout(() => {
		toast.classList.remove('show');
		toast.addEventListener('transitionend', () => toast.remove());
	}, 3000);
}

/**
 * Initializes the share modal for a hairstyle canvas.
 *
 * @param {Object} dom - The DOM elements object.
 * @param {HTMLElement} wrapper - The main wrapper element containing the modal.
 */
export default function initShareModal({ dom, wrapper }) {
	if (!dom.shareButton) return;

	dom.shareButton.addEventListener('click', async () => {
		const article = wrapper.closest('article');
		if (!article) return;

		const toHide = article.querySelectorAll(
			'.wp-block-mavis-design-a-hairstyle__game-logo, ' +
				'.wp-block-mavis-design-a-hairstyle__game-options, ' +
				'.wp-block-mavis-design-a-hairstyle__clear-button, ' +
				'.wp-block-mavis-design-a-hairstyle__undo-button, ' +
				'.wp-block-mavis-design-a-hairstyle__share-button,' +
				'.wp-block-mavis-design-a-hairstyle__start-over-button',
		);

		// Hide logo + buttons temporarily so they don’t show up in the screenshot
		toHide.forEach((el) => {
			// eslint-disable-next-line
			el.style.visibility = 'hidden';
		});

		const exportCanvas = await html2canvas(article, {
			backgroundColor: null,
			useCORS: true,
			scale: 2,
		});

		toHide.forEach((el) => {
			// eslint-disable-next-line
			el.style.visibility = '';
		});

		const dataUrl = exportCanvas.toDataURL('image/png');

		const modal = wrapper.querySelector('.mavis-share-modal');
		if (!modal) return;

		const preview = modal.querySelector('.mavis-share-modal__preview');
		if (preview) preview.src = dataUrl;
		modal.classList.add('is-active');

		const closeBtn = modal.querySelector('.mavis-share-modal__close');
		if (closeBtn) {
			/**
			 * Close the share modal
			 */
			closeBtn.onclick = () => {
				modal.classList.remove('is-active');
			};
		}

		const downloadBtn = modal.querySelector('.mavis-share-modal__download');
		if (downloadBtn) {
			/**
			 * Download the hairstyle image
			 */
			downloadBtn.onclick = () => {
				const link = document.createElement('a');
				link.href = dataUrl;
				link.download = 'hairstyle.png';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			};
		}

		// The Share button
		const copyBtn = modal.querySelector('.mavis-share-modal__share');

		if (copyBtn) {
			/**
			 * Copy the hairstyle image to the clipboard, using a Promise-based
			 * approach for Safari compatibility.
			 */
			copyBtn.onclick = async () => {
				try {
					const blobPromise = new Promise((resolve) => exportCanvas.toBlob(resolve, 'image/png'));

					const clipboardItem = new ClipboardItem({
						'image/png': blobPromise,
					});

					await navigator.clipboard.write([clipboardItem]);

					// Show success message
					showToastMessage('Image copied to clipboard!');
				} catch (err) {
					// Show error message
					showToastMessage('Could not copy image.');
				}
			};
		}
	});
}
